/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import {
  WorkPackageStatuses,
  HigherLevelStatuses
} from '../constants/storyStatusTypes';

export function resultCardId(result) {
  let id = '';
  const firstLetter =
    result.result_type &&
    result.result_type.kind &&
    result.result_type.kind.length > 0
      ? result.result_type.kind[0]
      : 'U';

  if ([4,3,2].includes(result.level)) {
    id = `${firstLetter}${result.type_id}`;
  } else if (result.type && result.type !== 'Result') {
    const initial = result.type[0];
    id = initial === 'A' ? 'Activity' : `${initial}${result.type_id}`;
  } else if (
    result.result_type &&
    result.result_type.kind &&
    result.result_type.kind.length > 0
  ) {
    id = `${firstLetter}${result.type_id}`;
  }
  return id;
}

export const capitalizeWord = (str) => {
  const firstLetter = str[0];
  const splitString = str.split('');
  splitString.shift();
  splitString.unshift(firstLetter.toUpperCase());
  return splitString.join('');
};

export const taskId = (task, workPackageTypeId) => {
  const typeId = task.work_package
    ? task.work_package.type_id
    : workPackageTypeId;

  return `T${typeId}.${task.item_id}`;
};

export function resultTypeName(result) {
  let name = '';
  if (result.type !== 'Result') {
    name = result.type;
  } else {
    name = result.result_type.kind;
    const splitPoint = name.split(/.*([A-Z])/)[1];
    if (splitPoint !== name[0]) {
      name = `${name.split(splitPoint).join(` ${splitPoint}`)}`;
    }
  }
  return name;
}

const workPackageStateLabel = (workPackage) => {
  const levelStatekeys =
    workPackage.level === 1 ? WorkPackageStatuses : HigherLevelStatuses;
  // translate the state, which is a standard back end work package status regardless of level, to the level-specific label
  const key = Object.entries(WorkPackageStatuses).find(
    (entry) => entry[1] === workPackage.state
  )[0];
  return levelStatekeys[key];
};

export const workPackageStateCharacter = (workPackage, requestedState) => {
  const { level, state: wpState } = workPackage;
  const state = requestedState || wpState;

  if (state === 'In Progress') return level === 1 ? 'P' : 'I'; // level 1s abbreviate as P
  if (requestedState) return requestedState.charAt(0); // for menu options

  // in some legacy cases, the state on the work package is in the form of IN_PROGRESS or NOT_READY; this is deprecated
  // and should be replaced with the state assigned by the backend
  const options = level === 1 ? WorkPackageStatuses : HigherLevelStatuses;
  if (options[state]) {
    // eslint-disable-next-line no-console
    console.warn(
      'DEPRECATED work package state encountered in workPackageStateCharacter',
      state
    );
    return options[state].charAt(0);
  }
  return workPackageStateLabel(workPackage).charAt(0);
};

export function hyphenate(string) {
  return string.replace(/\s+/g, '-').toLowerCase();
}

export function parsePath(path, value) {
  const splitPath = path.split('/');
  return splitPath.fill(value, -1).join('/');
}

export function truncate(word, limit = 12) {
  if (word.length > limit) {
    return `${word.substring(0, limit - 3).trim()}...`;
  }
  return word;
}

export function fromCamelCaseToNormal(word) {
  return word
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (str) => str.toUpperCase());
}

export const acronymGenerator = (str, limit, withPeriods = true) => {
  if (str.length < limit) return str.toUpperCase();

  const splitName = str.split(' ');
  const acronymArray = splitName.map((word) => word[0].toUpperCase());

  if (withPeriods) return `${acronymArray.join('.')}.`;

  return `${acronymArray.join('')}`;
};

export const initialsGenerator = (str) => {
  const upperCased = str.toUpperCase();
  const separated = upperCased.split(' ');
  const initialsArray = [];

  separated.forEach((word) => initialsArray.push(word[0]));
  return initialsArray.join(' ');
};
